import React from 'react'
import l8n from 'l8n';

const NotFoundPage = () =>
  <div className="text-center">
    <div className="w-50 d-inline-block pt-5 pb-5 mt-5 mb-5">
      <h1 className="mb-4">
        <strong>{l8n.p_error_404}</strong>
      </h1>
      <p className="mb-4">{l8n.p_error_404_text}</p>
    </div>
  </div>

export default NotFoundPage



// WEBPACK FOOTER //
// ./src/pages/NotFoundPage/index.js